// extracted by mini-css-extract-plugin
export default {"dropItem":"LeagueLeaders_dropItem__UvOXi","slideInDown":"LeagueLeaders_slideInDown__jtAIQ"};